import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { titleLengthHelper } from "../../../pages/postEditor/seoAnalyzer/h1Helper";

export default function H1Card({ analysis, content }) {
  const { t } = useTranslation();
  const length = useMemo(() => {
    return content?.url.full
      ? titleLengthHelper(
          analysis.h1_title.nb_characters,
          analysis.h1_title.nb_words
        ).score
      : 0;
  }, [analysis]);
  return analysis !== undefined && content !== undefined ? (
    <>
      <div className="py-3">
        <div className="break-words">
          {/* Title */}
          <div className="text-sm text-black font-bold  ">
            {content?.h1_title}
          </div>
          {/* Target request included */}
          <div className="text-xs mt-2 text-black  ">
            <span>
              {" "}
              {t("Target-request-included", "Target request included")}?
              <span
                className={`${
                  analysis?.h1_title.includes_seo_request == 2
                    ? "text-green-500"
                    : analysis?.h1_title.includes_seo_request == 1
                    ? "text-yellow-500"
                    : "text-red-600"
                }`}
              >
                {" "}
                {analysis?.h1_title.includes_seo_request == 2
                  ? t("Yes", "Yes")
                  : analysis?.h1_title.includes_seo_request == 1
                  ? t("Partially", "Partially")
                  : t("No", "No")}
              </span>
            </span>
          </div>

          {/* Title Length */}
          <div className="text-xs    text-black">
            <span>
              {" "}
              {t("Length", "Length")} :
              <span
                className={`${
                  length == 100
                    ? "text-green-500"
                    : length == 70
                    ? "text-yellow-500"
                    : "text-red-600"
                }`}
              >
                {" "}
                {analysis?.h1_title.nb_words} {t("word", "word")}
                {analysis?.h1_title.nb_words > 1 ? "s" : ""} ({" "}
                {analysis?.h1_title.nb_characters} {t("character", "character")}
                {analysis?.h1_title.nb_characters > 1 ? "s" : ""} )
              </span>
            </span>
          </div>
          {/* Other h1 titles  */}
          <div className="text-xs   text-black">
            <span>
              {t("Other-h1-titles", "Other h1 titles ")}?{" "}
              <span
                className={`${
                  analysis?.h1_title.nb_h1_titles == 1
                    ? "text-green-500"
                    : "text-red-600"
                }`}
              >
                {" "}
                {`${
                  analysis?.h1_title.nb_h1_titles > 1
                    ? t("Yes", "Yes")
                    : t("No", "No")
                } `}
              </span>
            </span>
          </div>

          {/*  All words different ?*/}
          <div className="text-xs   text-black">
            <span>
              {" "}
              {t("All-words-different", "All words different")}?{" "}
              <span
                className={`${
                  analysis?.h1_title.duplicated_keywords
                    ? "text-green-500"
                    : "text-red-600"
                }`}
              >
                {" "}
                {`${
                  analysis?.h1_title.duplicated_keywords
                    ? t("Yes", "Yes")
                    : t("No", "No")
                }`}
              </span>
            </span>
          </div>

          {/* Different than competitors? */}
          <div className="text-xs   text-black">
            <span>
              {" "}
              {t(
                "Different-than-competitors",
                "Different than competitors"
              )}?{" "}
              <span
                className={`${
                  analysis?.h1_title.is_unique
                    ? "text-green-500"
                    : "text-red-600"
                }`}
              >
                {" "}
                {`${
                  analysis?.h1_title.is_unique ? t("Yes", "Yes") : t("No", "No")
                }`}
              </span>
            </span>
          </div>
        </div>
      </div>
    </>
  ) : null;
}
